/**
 * Created by Languagenut on 18/04/2019.
 */

 
import React  from 'react';
import { ProgressBar , Button, Row, Col, Alert} from 'react-bootstrap'
import Select from  'react-select';
import FieldGroup from '../../FieldGroup.js'
import Summary from './assignment_edit_summary.js';
import { DateRangePicker} from 'react-dates';
import GeneralTable from '../../general_table.js';
import ClassesService from '../../../services/classes-service'
import ClassesStore from '../../../store/classes-store'
import Constants from '../../../constants.js';
import Translation from '../../../store/internationalization-store.js'
import HomeworkStore from '../../../store/homework-store'
import AssignmentsService from '../../../services/assignments-service'
import moment from 'moment';
import Checkbox from '../../checkbox.js';
import InformationPopup from '../../popup/information_popup.js'
import AssignmentService from '../../../services/assignments-service.js';
import UserService from '../../../services/user-service.js';

class AssignConfirmation extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {
            classes:[],
            comment:"",
            isRepeatable:false,
            startDate:moment(),
            endDate:moment().add(14, "days"),
            hasAddedComment:false,
            saveButtonPressed:false
        };
    }

    componentDidMount(){
        ClassesService.list();


        UserService.getAssignments();
        UserService.getArchivedAssignments();
    }

    componentWillReceiveProps(props){
        this.props = props;
    }

    componentWillMount(){

        AssignmentService.getSingleLibraryAssignment(this.props.homeworkID, this.props.curriculumID).then(function(homework){
            this.setState({homework:homework, hasLoaded:true})
        }.bind(this));

        ClassesStore.on(Constants.GET_CLASSES_LIST,  ()=>{
            var classes = ClassesStore.list;

            AssignmentsService.getUsersCompleted(this.props.information.homeworkID).then(function(students){

                var class_students = students;

                var student = function(classUID , class_students){
                    var s = [];

                    for(var i = 0 ; i < class_students.length; i++)
                    {
                        if(! class_students[i].classes) break;

                        for(var j = 0; j < class_students[i].classes.length; j++)
                        {
                            if(class_students[i].classes[j].uid == classUID)
                            {
                                s.push({ value:class_students[i].uid, label: class_students[i].student_name});
                            }
                        }
                    }

                    return s
                };

                var classStates = {};
                var classMine = [];
                for(var idx = 0 ; idx < classes.length; idx++)
                {
                    var selected = false;
                    var students = student(classes[idx].uid , class_students)
                    classStates[classes[idx].uid] = {allStudents:false , selected:selected ? true : students.length > 0 ? true : false , students:students};
                    if (classes[idx].isMine) {
                        classMine.push(classes[idx]);
                    }
                }

                this.setState({
                    classes:classes,
                    classStates:classStates,
                    classMine:classMine
                });

            }.bind(this));

        })
        
    }

    renderStudentsSelect(data){
        const options = (data.students || []).map(function(student){

            return  { value: student.uid, label: student.name}
        });

        if (data.selected == undefined ) {
            data.selected = this.state.classStates[data.uid].selected
            data.offsetChange = 1;
        }

        return [<Row><Col md={10}><Select placeholder={Translation.get(897 , 'All Students')}
                isMulti={true} value={this.state.classStates[data.uid].students} onChange={this.handelSelectStudents.bind(this , data)}  options={options}
                noResultsText={Translation.get(12715 , 'No Results Found')} /></Col><Col md={1}>
                       <div style={{marginTop:'8px'}}><Checkbox checked={data.selected} onChange={this.handelSelect.bind(this , data)} inline/></div></Col></Row>]

    }

    handelSelectRepeatable(event){


        var getComment = function(isRepeatable){

            let autoComment = Translation.get(12716 , 'You can repeat this assignment to improve your score');
            let comment = this.state.comment;

            comment = comment.replaceAll(autoComment, "");
            comment = comment.replace(/(^[ \t]*\n)/gm, "")
            if(isRepeatable)
            {
                comment += (comment.length > 1 ? '\n' : '' ) + Translation.get(12716 , 'You can repeat this assignment to improve your score')
            }

            return comment;
        }.bind(this);

        let isRepeatable = !this.state.isRepeatable;
        let comment = getComment(isRepeatable)

        this.setState({
            isRepeatable:!this.state.isRepeatable,
            hasAddedComment:isRepeatable,
            comment:comment
        });
    }

    handelSelect(data){
        var classID = data.uid;
        data.offsetChange++;
        var states = this.state.classStates;
        states[classID].selected = !states[classID].selected;
        states[classID].students = "";
        data.selected = states[classID].selected;

        var classes = [];

        for(var i = 0 ; i < this.state.classes.length; i++ )
        {
            if(classID == this.state.classes[i]['uid']) this.state.classes[i]['selected'] = states[classID].selected;
            classes.push(this.state.classes[i])
        }

        this.setState({classes:classes , classStates:states});
    }

    handelSelectStudents(data , value ){
        var classID = data.uid;
        data.offsetChange++;
        var states = this.state.classStates;
        states[classID].students = value;
        if (value == undefined || value == null) {
            states[classID].selected = false;
        } else {
            states[classID].selected = value.length > 0 ;
        }


        var classes = []

        for(var i = 0 ; i < this.state.classes.length; i++ )
        {
            if(classID == this.state.classes[i]['uid'])
            {
                this.state.classes[i]['selected'] = states[classID].selected;

                if(this.state.classes[i].students[this.state.classes[i].students.length - 1])
                {
                    if(this.state.classes[i].students[this.state.classes[i].students.length - 1].uid == 'remove')
                    {
                        this.state.classes[i].students.pop();
                    }
                    else
                    {
                        this.state.classes[i].students.push({uid:'remove'})
                    }
                }
                else
                {
                    this.state.classes[i].students.push({uid:'remove'})
                }

            }

            classes.push(this.state.classes[i])

        }

        this.setState({classes:classes , classStates:states});
    }


    convert(){
        var t = this.state.tasks;
        //  "type, uid, games, data, title, difficulty, exam_catalog_uid"
        var types = ['nothing', 'vocabs' , 'sentences' , 'verbs' , 'grammar' , 'exam' , 'custom'];
        for(var i = 0 ; i < t.length; i++)
        {
            var task = this.state.tasks[i]
            var games = [{uid:task.game_uid, title:task.gameTitle, isEnglish:false}]

            if(types[task.feature_uid] == 'sentences' || types[task.feature_uid] == 'grammar')
            {
                HomeworkStore.addNewEditTask(types[task.feature_uid], task.catalog_uid, games, [], "", undefined, undefined);
            }
            else if(types[task.feature_uid] == 'verbs')
            {
                var games = [{ uid:task.game_uid , title:task.gameTitle , isEnglish:true, difficulty:'' , exam_catalog_uid:''}]
                HomeworkStore.addNewEditTask(types[task.feature_uid], task.rel_module_uid, games, [], "", undefined, undefined);
            }
            else if(types[task.feature_uid] != 'exam')
            {
                HomeworkStore.addNewEditTask(types[task.feature_uid], task.rel_module_uid, games, [], "", undefined, undefined);
            }
            else
            {
                //type, uid, games, data, title, difficulty, exam_catalog_uid
                var games = [{uid:task.game_uid, title:task.gameTitle, isEnglish:task.question_ietf == 'en' , exam_catalog_uid:task.rel_module_uid , difficulty:task.difficulty  , skills:task.skill}];

                HomeworkStore.addNewEditTask(types[task.feature_uid], task.rel_module_uid, games, [], "", task.difficulty, task.rel_module_uid);
            }


        }
    }

    checkIsNotCorrect() {
        if (this.state.homeworkName != undefined && this.state.homeworkName != "" 
                && this.state.endDate != undefined && this.state.endDate != undefined) {
            for (var classUid in this.state.classStates){
                if (this.state.classStates.hasOwnProperty(classUid)) {
                    if (this.state.classStates[classUid].selected == true) {
                        return false;
                    }
                }
            }
        }
        return true;
    }

    hasOpenQuestions(homeworkTask){

        for(var j = 0 ; j < homeworkTask.length; j++){

            if(homeworkTask[j].game_uid == 206) return true;
            if(homeworkTask[j].game_uid == 207) return true;
        }

        return false;
    }

    onRemove(task){

        var tasks = [];

        if(this.state.tasks.length == 1)
        {
            return;
        }

        for(var i = 0; i < this.state.tasks.length; i++)
        {
            if(this.state.tasks[i].name != task.name)
            {
                tasks.push(this.state.tasks[i]);
            }
        }

        this.setState({
            tasks:tasks
        })
    }

    renderTime(time){

        function secondsToHms(d) {
            d = Number(d);
            if (d ==0) {
                return "-"
            }
            var h = Math.floor(d / 3600);
            var m = Math.floor(d % 3600 / 60);
            var s = Math.floor(d % 3600 % 60);

            if (h < 9) {
                h = "0"+h;
            }
            if (m < 9) {
                m = "0"+m;
            }
            if (s < 9) {
                s = "0"+s;
            }


            var hDisplay = h > 0 ? h + (h == 1 ? " hour, " : " hours, ") : "";
            var mDisplay = m > 0 ? m + (m == 1 ? " minute, " : " minutes") : "";
            var sDisplay = s > 0 ? s + (s == 1 ? " second" : " seconds") : "";

            return hDisplay+ mDisplay;
        }

        return secondsToHms(time);
    }

    render(){

        if(!this.state.loaded)
        return <ProgressBar animated now={45} />;

        var columns = [
            {
                dataField: 'name',
                text: Translation.get(827,'Student Name'),
            },
            {
                dataField: 'classes',
                text: Translation.get(830,'Classes'),
                sort: true,
                align: "left",
            },
            {
                dataField: 'rank',
                text: Translation.get(22,'Username'),
                sort: true,
                align: "left",
            },
            {
                dataField: 'rank',
                text: Translation.get(23,'Password'),
                sort: true,
                align: "left",
            },

        ];

        var columns = [
            {
                dataField: 'name',
                sort: true,
                text: Translation.get(819 , 'Class Name'),
            },{
                dataField: 'offsetChange',
                text: Translation.get(498 , 'Assign To'),
                align: "left",
                style:{
                    width:'60%'
                },
                formatter:function(cell , row){
                    return this.renderStudentsSelect(row)
                }.bind(this)
            }
        ];
        var buttontranslation2 = Translation.get(657 , 'Save');

        var AdvanceButton2 = React.createElement(Button, {
            onClick: function() { this.handleHomeworkSubmission.bind(this)().then(function(homeWorkUid){
                window.location.hash = "#/assignments/overview/"+homeWorkUid;
            }.bind(this)) }.bind(this),
            bsStyle:'primary',
            className:"btn-block",
            disabled:this.checkIsNotCorrect()
        },buttontranslation2);


        let repatable =  <div style={{marginTop:"10px", marginLeft:'0px'}} >
            <span style={{float:"left"}} onClick={this.handelSelectRepeatable.bind(this)}><Checkbox checked={this.state.isRepeatable} isDisabled label={<span>{Translation.get(2431 ,'Repeat Assignment')}&nbsp;&nbsp;</span>} className="float-left" type="checkbox"  /></span>
            <span><i onClick={()=>{this.setState({information:true})}} class="fas fa-info-circle"></i></span></div>;


        let alert = null;

        if(this.state.startDate)
        {
            if(this.state.startDate.isAfter(moment()))
            {
                alert = <Alert style={{marginTop:'10px'}} variant={'warning'} >
                    { Translation.get('0' , 'This assignment is set to start in the future and will not be visible to your students until the set date')}
                </Alert>
            }
        }

        var checkBoxStuff =  <span style={{paddingBottom:"10px"}} className="float-right" onClick={function() {
            var isAll = !this.state.isAll
            this.setState({isAll:isAll});
        }.bind(this)}> {Translation.get(12791, 'Show all Classes')}
            <Checkbox isDisabled checked={this.state.isAll}/></span>

        var dataUsed = this.state.classes;

        if (!this.state.isAll) {
            dataUsed = this.state.classMine;
        }

        var classData = <GeneralTable hideDownload secondary={checkBoxStuff} component={<div><span class="float-left">{AdvanceButton2}</span>&nbsp;</div>} columns={columns} data={dataUsed} />
        if (this.state.classLoading == false) {
            classData = <ProgressBar animated now={45} />
        }

        
        return <div>
            <InformationPopup title={Translation.get(12718 , ' About Repeatable Assignments')} show={this.state.information} onHide={()=>{this.setState({information:false})}}>
                {Translation.get(12719, 'The repeat assignment function allows your students to retake an assignment as many times as they wish to. If this is unticked, students will only be given one attempt.')}
            </InformationPopup>
            <Row>
                <Col md={12}>
                    <Row>
                        <Col md={8}>
                            <Row>
                                <Col md={12}><FieldGroup value={this.state.homeworkName} id="name" autofocus={true} label={Translation.get(2008,'Assignment Name')}  onChange={(event)=>{this.setState({homeworkName:event.target.value})}}/></Col>
                                <Col md={12}>
                                    <FieldGroup value={this.state.comment} style={{"resize":"none"}} as="textarea" rows="4" label={Translation.get(2432 ,'Add instructions/comments for this assignment which will be visible to students')}  onChange={(event)=>{this.setState({comment:event.target.value})}}/>
                                </Col>
                                <Col md={"auto"} style={{marginTop:"auto", marginBottom:"auto"}} >{Translation.get(2433 ,'Start Date - Due Date')}</Col>
                                <Col md={"auto"} style={{marginTop:"auto", marginBottom:"auto"}} >
                                    <DateRangePicker
                                        displayFormat='DD/MM/YYYY'
                                        className="hellp"
                                        customArrowIcon={<i class="fas fa-arrows-alt-h"></i>}
                                        startDate={this.state.startDate} // momentPropTypes.momentObj or null,
                                        startDateId="your_unique_start_date_id" // PropTypes.string.isRequired,
                                        endDate={this.state.endDate} // momentPropTypes.momentObj or null,
                                        endDateId="your_unique_end_date_id" // PropTypes.string.isRequired,
                                        onDatesChange={({ startDate, endDate }) => this.setState({ startDate, endDate })} // PropTypes.func.isRequired,
                                        focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                                        onFocusChange={focusedInput => this.setState({ focusedInput })} // PropTypes.func.isRequired,
                                        />
                                </Col>
                                <Col style={{marginTop:"auto", marginBottom:"auto"}} md={5} >
                                    {repatable}
                                </Col>
                                <Col md={12}>{alert}</Col>
                            </Row>

                        </Col>
                        <Col md={4}><div  style={{marginBottom:'8px'}}>{Translation.get(12720 , 'Assignment Summary')}</div>
                                <Summary tasks={this.state.tasks} types={this.props.data.types}/>
                                <div style={{marginTop:"10px", fontWeight:"bold"}}>{Translation.get(12790, 'Estimated assignment time:')}: {this.renderTime(this.state.tasks.length*180)}</div>
                        </Col>

                    </Row>
                    <Row>
                        <Col md={12}>
                            <hr/>
                            {classData}
                        </Col>

                    </Row>
                </Col>

        </Row>
            <Row>
                <Col sm={6}></Col>
                <Col sm={6}>{AdvanceButton2}</Col>
            </Row>
        </div>
    }


}


export default {
    name: function() {return Translation.get(2434,'Edit Existing')},
    icon:<i class="fa-2x fas fa-file-alt"></i>,
    title:null,
    disableButtons:true,
    onSubmit: function (done){
        done();
    },
    component: AssignConfirmation
}